/**
 * @desc 取消供应商认证
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<boolean>;
export function request(userNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierAccount/canselSupplierCertified/${userNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
